module.exports = __webpack_public_path__ + "img/广州增城金竹酒店项目.bfba0e2b.png";